import React from 'react'
import AdminPageWithSmartview from 'pages/app/AdminPageWithSmartview'
import Schedule from './partials/Schedule'
import WhenDeviceAuthorized from 'support/conditionals/WhenDeviceAuthorized'
import WhenDeviceNotAuthorized from 'support/conditionals/WhenDeviceNotAuthorized'

export default function ShiftsView (props) {
  return (
    <>
      <WhenDeviceAuthorized>
        <AdminPageWithSmartview withoutAllDepartments slideInSmartview>
          <Schedule mode='view' />
        </AdminPageWithSmartview>
      </WhenDeviceAuthorized>
      <WhenDeviceNotAuthorized>
        <AdminPageWithSmartview withoutAllDepartments>
          <Schedule mode='view' />
        </AdminPageWithSmartview>
      </WhenDeviceNotAuthorized>
    </>
  )
}
